module.exports = __webpack_public_path__ + "static/media/splash.8463f3d1.png";